import {WorkrequestBoeDetails} from './workrequest-boe-details';
import {WorkrequestViewmodelBase} from '../../shared/viewmodels/workrequest-viewmodel-base';

export class WorkrequestBoeViewmodel extends WorkrequestViewmodelBase {
  workrequestDetails: WorkrequestBoeDetails;
  errorMessage: string;
  invalidSelectionError;
  feeAmount;
  number;

  private garageCarportShed: boolean;
  private dwellingEaves: boolean;
  private cutFill: boolean;
  private basement: boolean;
  private building: boolean;
  private verandahPergola: boolean;
  private swimmingPoolSpa: boolean;
  private other: string;

  basementRequiredText = 'Basement';
  garageCarportShedRequiredText = 'Garage  / Carport / Shed';
  dwellingEavesRequiredText = 'Dwelling / Eaves';
  cutFillRequiredText = 'Cut / Fill';
  buildingRequiredText = 'Building - Commercial/Industrial';
  verandahPergolaRequiredText = 'Verandah / Pergola / Decking';
  swimmingPoolSpaRequiredText = 'Swimming Pool / Spa inc. Coping';


  constructor() {
    super();
    this.workrequestDetails = new WorkrequestBoeDetails();
    this.invalidSelectionError = 'Please select at least one work request option';
    this.errorMessage = null;
  }

  get otherRequired(): boolean {
    return !!this.other;
  }

  get otherText(): string {
    return this.other;
  }

  set otherText(v: string) {
    this.other = v;

    if (v) {
      this.workrequestDetails.selectedOptionText = v;
      this.garageCarportShed = false;
      this.dwellingEaves = false;
      this.cutFill = false;
      this.basement = false;
      this.building = false;
      this.verandahPergola = false;
      this.swimmingPoolSpa = false;
    }
  }

  get garageCarportShedRequired(): boolean {
    return this.garageCarportShed;
  }

  set garageCarportShedRequired(v: boolean) {
    this.garageCarportShed = v;
    if (!v) {
      if (this.workrequestDetails.selectedOptionText === this.garageCarportShedRequiredText) {
        this.workrequestDetails.selectedOptionText = '';
      }
    } else {
      this.workrequestDetails.selectedOptionText = this.garageCarportShedRequiredText;
      this.dwellingEaves = false;
      this.cutFill = false;
      this.basement = false;
      this.building = false;
      this.verandahPergola = false;
      this.swimmingPoolSpa = false;
      this.otherText = '';
    }
  }

  get dwellingEavesRequired(): boolean {
    return this.dwellingEaves;
  }

  set dwellingEavesRequired(v: boolean) {
    this.dwellingEaves = v;
    if (!v) {
      if (this.workrequestDetails.selectedOptionText === this.dwellingEavesRequiredText) {
        this.workrequestDetails.selectedOptionText = '';
      }
    } else {
      this.workrequestDetails.selectedOptionText = this.dwellingEavesRequiredText;
      this.garageCarportShed = false;
      this.cutFill = false;
      this.basement = false;
      this.building = false;
      this.verandahPergola = false;
      this.swimmingPoolSpa = false;
      this.otherText = '';
    }
  }

  get cutFillRequired(): boolean {
    return this.cutFill;
  }

  set cutFillRequired(v: boolean) {
    this.cutFill = v;
    if (!v) {
      if (this.workrequestDetails.selectedOptionText === this.cutFillRequiredText) {
        this.workrequestDetails.selectedOptionText = '';
      }
    } else {
      this.workrequestDetails.selectedOptionText = this.cutFillRequiredText;
      this.garageCarportShed = false;
      this.dwellingEaves = false;
      this.basement = false;
      this.building = false;
      this.verandahPergola = false;
      this.swimmingPoolSpa = false;
      this.otherText = '';
    }
  }

  get basementRequired(): boolean {
    return this.basement;
  }

  set basementRequired(v: boolean) {
    this.basement = v;
    if (!v) {
      if (this.workrequestDetails.selectedOptionText === this.basementRequiredText) {
        this.workrequestDetails.selectedOptionText = '';
      }
    } else {
      this.workrequestDetails.selectedOptionText = this.basementRequiredText;
      this.garageCarportShed = false;
      this.dwellingEaves = false;
      this.cutFill = false;
      this.building = false;
      this.verandahPergola = false;
      this.swimmingPoolSpa = false;
      this.otherText = '';
    }
  }

  get buildingRequired(): boolean {
    return this.building;
  }

  set buildingRequired(v: boolean) {
    this.building = v;
    if (!v) {
      if (this.workrequestDetails.selectedOptionText === this.buildingRequiredText) {
        this.workrequestDetails.selectedOptionText = '';
      }
    } else {
      this.workrequestDetails.selectedOptionText = this.buildingRequiredText;
      this.garageCarportShed = false;
      this.dwellingEaves = false;
      this.cutFill = false;
      this.basement = false;
      this.verandahPergola = false;
      this.swimmingPoolSpa = false;
      this.otherText = '';
    }
  }

  get verandahPergolaRequired(): boolean {
    return this.verandahPergola;
  }

  set verandahPergolaRequired(v: boolean) {
    this.verandahPergola = v;
    if (!v) {
      if (this.workrequestDetails.selectedOptionText === this.verandahPergolaRequiredText) {
        this.workrequestDetails.selectedOptionText = '';
      }
    } else {
      this.workrequestDetails.selectedOptionText = this.verandahPergolaRequiredText;
      this.garageCarportShed = false;
      this.dwellingEaves = false;
      this.cutFill = false;
      this.basement = false;
      this.building = false;
      this.swimmingPoolSpa = false;
      this.otherText = '';
    }
  }

  get swimmingPoolSpaRequired(): boolean {
    return this.swimmingPoolSpa;
  }

  set swimmingPoolSpaRequired(v: boolean) {
    this.swimmingPoolSpa = v;
    if (!v) {
      if (this.workrequestDetails.selectedOptionText === this.swimmingPoolSpaRequiredText) {
        this.workrequestDetails.selectedOptionText = '';
      }
    } else {
      this.workrequestDetails.selectedOptionText = this.swimmingPoolSpaRequiredText;
      this.garageCarportShed = false;
      this.dwellingEaves = false;
      this.cutFill = false;
      this.basement = false;
      this.building = false;
      this.verandahPergola = false;
      this.otherText = '';
    }
  }

  get isValid(): boolean {
    return this.dwellingEavesRequired ||
      this.basementRequired ||
      this.buildingRequired ||
      this.cutFillRequired ||
      this.garageCarportShedRequired ||
      this.swimmingPoolSpaRequired ||
      this.verandahPergolaRequired ||
      this.otherRequired;
  }
}



// WEBPACK FOOTER //
// ./src/app/create-application/boe-form/workrequest-boe-viewmodel.ts